import config from "./config";

const directory = config.sevenwords.directory;
const sevenWords = [
    {
        category: "001_BallGames",
        link: `${config.flashUrl}/${directory}/001_BallGames`,
        target: true
    },
    {
        category: "002_LivingRoom",
        link: `${config.flashUrl}/${directory}/002_LivingRoom`,
        target: true
    },
    {
        category: "003_lunch",
        link: `${config.flashUrl}/${directory}/003_lunch`,
        target: true
    },
    {
        category: "004_Barbecue",
        link: `${config.flashUrl}/${directory}/004_Barbecue`,
        target: true
    },
    {
        category: "005_desk",
        link: `${config.flashUrl}/${directory}/005_desk`,
        target: true
    },
    {
        category: "006_HairSalon",
        link: `${config.flashUrl}/${directory}/006_HairSalon`,
        target: true
    },
    {
        category: "007_Kitchen",
        link: `${config.flashUrl}/${directory}/007_Kitchen`,
        target: true
    },
    {
        category: "008_Refrigerator",
        link: `${config.flashUrl}/${directory}/008_Refrigerator`,
        target: true
    },
    {
        category: "009_Bathroom",
        link: `${config.flashUrl}/${directory}/009_Bathroom`,
        target: true
    },
    {
        category: "010_Closet",
        link: `${config.flashUrl}/${directory}/010_Closet`,
        target: true
    },
    {
        category: "011_StreetIntersection",
        link: `${config.flashUrl}/${directory}/011_StreetIntersection`,
        target: true
    },
    {
        category: "012_DiningTable",
        link: `${config.flashUrl}/${directory}/012_DiningTable`,
        target: true
    },
    {
        category: "013_Toolbox",
        link: `${config.flashUrl}/${directory}/013_Toolbox`,
        target: true
    },
    {
        category: "014_CheckoutCounter",
        link: `${config.flashUrl}/${directory}/014_CheckoutCounter`,
        target: true
    },
    {
        category: "015_Classroom",
        link: `${config.flashUrl}/${directory}/015_Classroom`,
        target: true
    },
    {
        category: "016_DeskTop",
        link: `${config.flashUrl}/${directory}/016_DeskTop`,
        target: true
    },
    {
        category: "017_FastFood",
        link: `${config.flashUrl}/${directory}/017_FastFood`,
        target: true
    },
    {
        category: "018_Fruit",
        link: `${config.flashUrl}/${directory}/018_Fruit`,
        target: true
    },
    {
        category: "019_Head",
        link: `${config.flashUrl}/${directory}/019_Head`,
        target: true
    },
    {
        category: "020_Sick",
        link: `${config.flashUrl}/${directory}/020_Sick`,
        target: true
    },
    {
        category: "021_Food",
        link: `${config.flashUrl}/${directory}/021_Food`,
        target: true
    },
    {
        category: "022_Animals",
        link: `${config.flashUrl}/${directory}/022_Animals`,
        target: true
    },
    {
        category: "023_MusicalInstruments",
        link: `${config.flashUrl}/${directory}/023_MusicalInstruments`,
        target: true
    },
    {
        category: "024_Bird",
        link: `${config.flashUrl}/${directory}/024_Bird`,
        target: true
    },
    {
        category: "025_WatchingTV",
        link: `${config.flashUrl}/${directory}/025_WatchingTV`,
        target: true
    },
    {
        category: "026_transport",
        link: `${config.flashUrl}/${directory}/026_transport`,
        target: true
    },
    {
        category: "027_PublicTransport",
        link: `${config.flashUrl}/${directory}/027_PublicTransport`,
        target: true
    }
];

export default sevenWords;
